import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Dialog, Grid, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import RegraObrigatoriedade from 'esocial.web.react.lib/cjs/components/form/Validation/RegraObrigatoriedade';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import { CustomDialogActions, CustomDialogContent, CustomDialogTitle } from 'esocial.web.react.lib/cjs/components/util/Dialog';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import { CustomTable } from 'esocial.web.react.lib/cjs/components/util/Table';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { abrirModalConfirmacao, fecharModalConfirmacao } from "esocial.web.react.lib/cjs/store/reducers/modais";
import { calcularHashDeString, obterObjetoTodosComponentesIntocados, obterObjetoTodosComponentesTocados, retornarFocoParaBotaoChamador, rolarVisualizacaoAteElementoInvalido, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { useEffect, useRef, useState } from 'react';

const ButtonTextPrimary = styled(IconButton)(({ theme }) => ({
    color: theme.palette.text.primary,
}));

const ContainerBotoesTabelaAcao = styled(TableCell)(({ theme }) => ({
    '& > *': {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

function calcularHashItem(item) {
    return calcularHashDeString(`${item.documentoAvaliacao}`);
}

const chaveNovoItem = 'n';
const sufixoChaveExcluirItem = '_e';

function Epis(props) {
    // Trecho reservado para ajuste no retorno da modal de inserir/editar item
    const action = useRef(null);
    const ref = useRef(null);

    const [chaveActionRefAtual, setChaveActionRefAtual] = useState(null);
    // Fim de Trecho reservado para ajuste no retorno da modal de inserir/editar item

    const [habilitarEdicaoAtualizacao, setHabilitarEdicaoAtualizacao] = useState(false);
    const [habilitarInsercaoAtualizacao, setHabilitarInsercaoAtualizacao] = useState(false);

    const dispatch = useAppDispatch();

    function excluirItem(indice, hashExclusao) {
        const modalConfirmacaoProps = {
            texto: 'Tem certeza que deseja excluir "EPI"?',
            textoBotaoNao: 'Não',
            textoBotaoSim: 'Sim',
            actionBotaoNao: () => {
                setChaveActionRefAtual(hashExclusao);
                retornarFocoParaBotaoChamador(action, ref);
                dispatch(fecharModalConfirmacao());
            },
            actionBotaoSim: async () => {
                props.setModelo({
                    ...props.modelo,
                    itemAgenteNocivoAuxiliar: {
                        ...props.modelo.itemAgenteNocivoAuxiliar,
                        epc: {
                            ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                            listaEpis: props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis.filter((l) => l !== props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis[indice]),
                            epis: props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis.filter((l) => l !== props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis[indice])
                        }
                    }
                });

                // Ao excluir um item, retornar o foco ao botão de inclusão de novo item
                setChaveActionRefAtual(chaveNovoItem);
                retornarFocoParaBotaoChamador(action, ref);
            }
        };

        dispatch(abrirModalConfirmacao(modalConfirmacaoProps));
    }

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};

    objetoComponentesTocados['itemEpiAuxiliar.documentoAvaliacao'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});

    useEffect(() => {
        const objetoRegrasValidacao = {};

        if (props.modelo != null) {
            objetoRegrasValidacao['itemEpiAuxiliar.documentoAvaliacao'] = new RegraObrigatoriedade(props.modelo.itemEpiAuxiliar.documentoAvaliacao.valor, componenteTocadoFormulario['itemEpiAuxiliar.documentoAvaliacao']);
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [props.modelo, componenteTocadoFormulario]);

    const [nomeFuncaoAcaoFormularioCompletamenteValidado, setNomeFuncaoAcaoFormularioCompletamenteValidado] = useState(null);

    useEffect(() => {
        const valoresValidacaoFormulario = Object.values(regraValidacaoFormulario).filter((x) => typeof x !== 'boolean');

        if (regraValidacaoFormulario.todosComponentesTocados) {
            if (typeof nomeFuncaoAcaoFormularioCompletamenteValidado === 'string' && valoresValidacaoFormulario.length > 0) {
                if (!new ListaRegraValidacao(valoresValidacaoFormulario).existeErro()) {
                    if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'inserirItem') {
                        inserirItem();
                    }
                    else if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'editarItem') {
                        editarItem();
                    }

                    retornarFocoParaBotaoChamador(action, ref);
                }
                else {
                    rolarVisualizacaoAteElementoInvalido('modalExames');
                }
            }

            setNomeFuncaoAcaoFormularioCompletamenteValidado(null);
        }
    }, [nomeFuncaoAcaoFormularioCompletamenteValidado, regraValidacaoFormulario.todosComponentesTocados]);

    const habilitarEdicaoItem = () => {
        setHabilitarEdicaoAtualizacao(true);
    };

    function cancelar() {
        setHabilitarEdicaoAtualizacao(false);
        setHabilitarInsercaoAtualizacao(false);

        // Limpar os valores dos campos auxiliares
        props.setModelo({
            ...props.modelo,
            itemEpiAuxiliar: {
                documentoAvaliacao: { ...props.modelo.itemEpiAuxiliar.documentoAvaliacao, valor: '' }
            }
        });

        retornarFocoParaBotaoChamador(action, ref);
    }

    const novoItem = () => {
        setComponenteTocadoFormulario(obterObjetoTodosComponentesIntocados(componenteTocadoFormulario));
        setHabilitarInsercaoAtualizacao(true);
        setChaveActionRefAtual(chaveNovoItem);
    };

    function inserirItem() {
        const itemLista = {
            documentoAvaliacao: props.modelo.itemEpiAuxiliar.documentoAvaliacao.valor
        };

        props.setModelo({
            ...props.modelo,
            itemAgenteNocivoAuxiliar: {
                ...props.modelo.itemAgenteNocivoAuxiliar,
                epc: {
                    ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                    listaEpis: [...props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis, itemLista],
                    epis: [...props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis, itemLista]
                }
            },
            itemEpiAuxiliar: {
                documentoAvaliacao: { ...props.modelo.itemEpiAuxiliar.documentoAvaliacao, valor: '' }
            }
        });

        setHabilitarInsercaoAtualizacao(false);
    }

    function copiarItem(indice, hash) {
        habilitarEdicaoItem();

        props.setModelo({
            ...props.modelo,
            itemEpiAuxiliar: {
                chave: indice,
                documentoAvaliacao: { ...props.modelo.itemEpiAuxiliar.documentoAvaliacao, valor: props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis[indice].documentoAvaliacao }
            }
        });

        setChaveActionRefAtual(hash);
    }

    function editarItem() {
        const itemLista = {
            documentoAvaliacao: props.modelo.itemEpiAuxiliar.documentoAvaliacao.valor
        };

        // Nesse ponto sabemos que o item pôde ser editado e chave para localização do botão com action e ref
        // de destino do foco deve ser recalculado em termos dos componentes do item
        const hash = calcularHashItem(itemLista);
        setChaveActionRefAtual(hash);

        let chaveAlteracao = props.modelo.itemEpiAuxiliar.chave;

        props.setModelo({
            ...props.modelo,
            itemAgenteNocivoAuxiliar: {
                ...props.modelo.itemAgenteNocivoAuxiliar,
                epc: {
                    ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                    listaEpis: [...props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis.filter((l) => l !== props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis[chaveAlteracao]), itemLista],
                    epis: [...props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis.filter((l) => l !== props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis[chaveAlteracao]), itemLista]
                }
            },
            itemEpiAuxiliar: {
                documentoAvaliacao: { ...props.modelo.itemEpiAuxiliar.documentoAvaliacao, valor: '' }
            }
        });

        setHabilitarEdicaoAtualizacao(false);
    }

    function atualizarItem() {
        setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
        setNomeFuncaoAcaoFormularioCompletamenteValidado(habilitarEdicaoAtualizacao ? 'editarItem' : 'inserirItem');
    }

    return (
        (props.modelo !== null && Object.values(regraValidacaoFormulario).length > 0) &&
        <Fieldset legend="Equipamento Proteção Individual - EPI" spacing={4} FieldsetProps={{ style: { marginTop: '1rem', paddingBlockEnd: '1rem' } }}>
            <Display show={!props.somenteVisualizacao}>
                <Grid item style={{ flexBasis: '100%', paddingTop: '0.3rem' }}>
                    <Button color="primary"
                        startIcon={<AddIcon />}
                        onClick={() => novoItem()}
                        disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                        action={chaveActionRefAtual === chaveNovoItem ? action : undefined}
                        ref={chaveActionRefAtual === chaveNovoItem ? ref : undefined}
                    >
                        Incluir EPI
                    </Button>
                </Grid>
            </Display>

            {/*Modal para inserção/edição de EPI*/}
            <Dialog
                open={(habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao) && !props.somenteVisualizacao}
                onClose={() => { cancelar() }}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth={false}
                PaperProps={{ id: 'modalEpis' }}
            >
                <CustomDialogTitle id="form-dialog-title">{habilitarInsercaoAtualizacao ? 'Incluir' : 'Editar'} EPI</CustomDialogTitle>
                <CustomDialogContent>
                    <Fieldset spacing={4}>
                        <VepTextField
                            accessor="itemEpiAuxiliar.documentoAvaliacao"
                            label="Certificado de Aprovação - CA ou documento de avaliação do EPI"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={12}
                            required
                            {...regraValidacaoFormulario['itemEpiAuxiliar.documentoAvaliacao'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemEpiAuxiliar.documentoAvaliacao': true })}
                        />
                    </Fieldset>
                </CustomDialogContent>
                <CustomDialogActions>
                    <Button variant="text" color="secondary" onClick={() => cancelar()}>
                        Cancelar
                    </Button>
                    <Button variant="text" color="primary" onClick={() => atualizarItem()}>
                        Salvar
                    </Button>
                </CustomDialogActions>
            </Dialog>

            <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis.length > 0}>
                <Grid item style={{ flexBasis: '100%' }}>
                    <CustomTable>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Documento Avaliação</TableCell>
                                <Display show={!props.somenteVisualizacao}>
                                    <TableCell align="center">Ação</TableCell>
                                </Display>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis.map((linha, indice) => {
                                const hash = calcularHashItem(linha);
                                const hashExclusao = `${hash}${sufixoChaveExcluirItem}`;

                                return (
                                    <TableRow key={indice}>
                                        <TableCell align="center">{linha.documentoAvaliacao}</TableCell>
                                        <Display show={!props.somenteVisualizacao}>
                                            <ContainerBotoesTabelaAcao align="center">
                                                <ButtonTextPrimary
                                                    color="inherit"
                                                    size="small"
                                                    aria-label="editar item"
                                                    onClick={() => copiarItem(indice, hash)}
                                                    disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                                                    action={chaveActionRefAtual === hash ? action : undefined}
                                                    ref={chaveActionRefAtual === hash ? ref : undefined}
                                                >
                                                    <EditIcon fontSize="small" />
                                                </ButtonTextPrimary>

                                                <IconButton
                                                    color="inherit"
                                                    size="small"
                                                    aria-label="excluir item"
                                                    onClick={() => excluirItem(indice, hashExclusao)}
                                                    disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                                                    action={chaveActionRefAtual === hashExclusao ? action : undefined}
                                                    ref={chaveActionRefAtual === hashExclusao ? ref : undefined}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </ContainerBotoesTabelaAcao>
                                        </Display>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </CustomTable>
                </Grid>
            </Display>

            <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis.length < 1}>
                <Grid item style={{ flexBasis: '100%' }}>
                    <Typography>Nenhum EPI cadastrado</Typography>
                </Grid>
            </Display>
        </Fieldset>
    );
}

export default Epis;
